import React from 'react';
import './AppFooter.scss';

export const AppFooter = ({ ...rest }) => {
  return <footer className='footer' {...rest} />;
};
